import React, { Ref, forwardRef } from 'react'
import ListItem from '@mui/material/ListItem'
import { NavLink, NavLinkProps, useLocation } from 'react-router-dom'
import { ISidebarMenuItem } from './Menu'
import { useIsRouteOrChildActiveFunc } from './use-is-route-or-child-active'

interface SidebarMenuItemComponentProps {
  name: string
  className?: string
  link?: string
  onClick: (event: React.MouseEvent<HTMLElement>) => void
  onHover: (event: React.MouseEvent<EventTarget>, ID: string) => void
  ID: string
  children?: React.ReactNode
  drawerOpen: boolean
  exact?: boolean
  items?: ISidebarMenuItem[]
}

export const SidebarMenuItemComponent: React.FC<SidebarMenuItemComponentProps> = props => {
  const { name, className, onClick, link, children, drawerOpen, onHover, ID, exact, items } = props
  const location = useLocation()
  const activeForSelfOrChildren = useIsRouteOrChildActiveFunc(location.pathname, items)

  return (
    <ListItem
      data-testid={`menu-item-${name}`}
      button
      className={className}
      onClick={onClick}
      exact={exact}
      onMouseEnter={(e: React.MouseEvent<EventTarget>) => (!drawerOpen ? onHover(e, ID) : undefined)}
      // there's probably a better way to do this, but during mui4 -> 5 migration we didn't want to make any functional changes
      component={
        forwardRef((props: NavLinkProps, ref: Ref<HTMLAnchorElement>) => (
          <NavLink ref={ref} {...props} to={link ?? ''} activeClassName={items?.length ? 'activeParent' : 'active'} />
        )) as any
      }
      isActive={activeForSelfOrChildren}
    >
      {children}
    </ListItem>
  )
}
